import {BaseObject} from "@/common/BaseObject";
import {alias, createModelSchema, custom, deserialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {MapGroupModel} from "@/modules/redactor/models/map/MapGroupModel";
import {Point} from "@/modules/redactor/models/utils/Point";

export class MapKindModel extends BaseObject {
    constructor(
        key = null,
        code = null,
        group = null,
        energyKind = null,
        welcomeTile = null,
    ) {
        super();

        this._key = key;
        this._code = code;
        this._group = group;
        this._energyKind = energyKind;
        this._welcomeTile = welcomeTile;
    }

    static schema() {
        return custom(
          (v) => {
              return v && v.key ? v.key : SKIP;
          },

          v => {
              if (typeof v === 'string') {
                  return RedactorUtils.getMapKindByKey(v);
              } else if (typeof v === 'object' && v !== null) {
                  return deserialize(MapKindModel, v);
              } else {
                  return null;
              }
          }
        );
    }

    static isNone(value) {
        return value instanceof MapKindModel && value.key === "none";
    }

    static getNone(items) {
        return items.find(item => item?.key === 'none')?.key || "none";
    }

    static isEmpty(val) {
        return val === '' || val === null || val === undefined;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get code() {
        return this._code;
    }

    set code(value) {
        this._code = value;
    }

    get group() {
        return this._group;
    }

    set group(value) {
        this._group = value;
    }

    get energyKind() {
        return this._energyKind;
    }

    set energyKind(value) {
        this._energyKind = value;
    }

    get energyKindObj() {
        if (!this._energyKind) {
            return null;
        }
        return RedactorUtils.getCurrencyKinds().find(item => item.key === this._energyKind) || null;
    }

    get welcomeTile() {
        return this._welcomeTile;
    }

    set welcomeTile(value) {
        this._welcomeTile = value;
    }

    valid() {
        if (typeof this.key !== "string" || !this.key.trim()) {
            return false;
        }

        if (!Number.isInteger(this.code) || this.code < 0) {
            return false;
        }

        if (this.welcomeTile && !this.welcomeTile.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new MapKindModel());
        } else if (target instanceof MapKindModel) {
            return super.clone(target);
        } else {
            console.log(false);
            return undefined;
        }
    }
}

createModelSchema(MapKindModel, {
    _key: alias("key", Schema.primitive()),
    _code: alias("code", Schema.number()),
    _group: alias("group", MapGroupModel.schema()),
    _energyKind: alias("energy_kind", Schema.string()),
    _welcomeTile: alias("welcome_tile", Point.schema()),
});